'use strict'

var DEFAULT_FILENAME = 'sentrykit-competing-sellers.csv'

/** Query string for GET /api/v1/account-sellers/report. Omits empty filters. */
export function accountSellersReportQueryString (params) {
  params = params || {}
  var parts = []
  var sellerId = params.sellerId
  if (sellerId != null && sellerId !== '') {
    parts.push('seller_id=' + encodeURIComponent(String(sellerId)))
  }
  var marketplace = params.marketplace
  if (marketplace != null && String(marketplace).trim() !== '') {
    parts.push('marketplace=' + encodeURIComponent(String(marketplace).trim()))
  }
  // Activity window (YYYY-MM-DD) and file type for the Export modal.
  ;['from', 'to'].forEach(function (key) {
    var v = params[key]
    if (v != null && String(v).trim() !== '') parts.push(key + '=' + encodeURIComponent(String(v).trim()))
  })
  if (params.fileFormat === 'xlsx') parts.push('file_format=xlsx')
  return parts.join('&')
}

/** Same headers as the server report, so "Export selected" opens like the full export. */
export var SELLER_EXPORT_HEADERS = [
  'Merchant Token ID', 'Seller Name', 'Role', 'Marketplace', 'ASIN Count', 'First Seen', 'Last Seen', 'ASINs'
]

/** One CSV cell: quoted when needed, and prefixed with ' when it would start a spreadsheet formula. */
export function csvCell (value) {
  var text = value == null ? '' : String(value)
  if (/^[=+\-@\t\r]/.test(text)) text = "'" + text
  if (/[",\n\r]/.test(text)) text = '"' + text.replace(/"/g, '""') + '"'
  return text
}

/** CSV text (with BOM) for rows already shaped as arrays matching SELLER_EXPORT_HEADERS. */
export function sellersCsv (rows) {
  var lines = [SELLER_EXPORT_HEADERS.map(csvCell).join(',')]
  ;(rows || []).forEach(function (cells) { lines.push(cells.map(csvCell).join(',')) })
  return '\uFEFF' + lines.join('\r\n') + '\r\n'
}

export function accountSellersReportUrl (params) {
  var qs = accountSellersReportQueryString(params)
  return '/api/v1/account-sellers/report' + (qs ? '?' + qs : '')
}

export function filenameFromContentDisposition (header, fallback) {
  var defaultName = fallback || DEFAULT_FILENAME
  if (!header) return defaultName
  var quoted = String(header).match(/filename="([^"]+)"/)
  if (quoted && quoted[1]) return quoted[1]
  var any = String(header).match(/filename\*?=(?:UTF-8''|['"]?)([^;\n"]+)/i)
  if (any && any[1]) {
    try {
      return decodeURIComponent(any[1].replace(/['"]/g, '').trim()) || defaultName
    } catch (e) {
      var name = any[1].replace(/['"]/g, '').trim()
      if (name) return name
    }
  }
  return defaultName
}

/** True when the CSV has at least one data row. Strips a leading BOM for the check only. */
export function csvHasDataRows (text) {
  var s = String(text == null ? '' : text).replace(/^\uFEFF/, '')
  s = s.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
  var lines = s.split('\n')
  var count = 0
  for (var i = 0; i < lines.length; i++) {
    if (lines[i].trim() !== '') count++
    if (count > 1) return true
  }
  return false
}

export function triggerBlobDownload (blob, filename) {
  if (!blob || typeof document === 'undefined') return
  var url = window.URL.createObjectURL(blob)
  var link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename || DEFAULT_FILENAME)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}



// WEBPACK FOOTER //
// ./src/utils/accountSellersReport.js